/**
 * BrandAuditDetailContainer
 * --
 */
import React from 'react';
import BrandAuditDetailPresenter from './BrandAuditDetailPresenter';

const BrandAuditDetailContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <BrandAuditDetailPresenter />
    </>
  );
};

export default BrandAuditDetailContainer;
